import React from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

const InventarioGranelSection = ({
  granelRecords,
  isFormOpen,
  setIsFormOpen,
  fechaMovimiento,
  setFechaMovimiento,
  idContenedor,
  setIdContenedor,
  noLote,
  setNoLote,
  categoria,
  setCategoria,
  clase,
  setClase,
  ingrediente,
  setIngrediente,
  edad,
  setEdad,
  tipoMaguey,
  setTipoMaguey,
  noAnalisis,
  setNoAnalisis,
  invInicialVol,
  setInvInicialVol,
  invInicialAlc,
  setInvInicialAlc,
  entradaProcedencia,
  setEntradaProcedencia,
  entradaVolumen,
  setEntradaVolumen,
  entradaAlc,
  setEntradaAlc,
  entradaVolAgua,
  setEntradaVolAgua,
  salidaVolumen,
  setSalidaVolumen,
  salidaAlc,
  setSalidaAlc,
  salidaDestino,
  setSalidaDestino,
  invFinalVol,
  setInvFinalVol,
  invFinalAlc,
  setInvFinalAlc,
  observaciones,
  setObservaciones,
  handleSaveGranel
}) => {
  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Inventarios de Mezcal a Granel (Sección II)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Nuevo Registro de Granel</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="10" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Datos Generales / Identificación del Mezcal</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Inventario Inicial</th>
                <th colSpan="4" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Entradas</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Salidas</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Inventario Final</th>
                <th colSpan="3" style={{ textAlign: "center" }}>Finalización</th>
              </tr>
              <tr>
                {/* Identificacion */}
                <th>Fecha Mov.</th>
                <th>Contenedor</th>
                <th>Nº Lote</th>
                <th>Categoría</th>
                <th>Clase</th>
                <th>Ingrediente</th>
                <th>Edad</th>
                <th>Tipo Maguey</th>
                <th>Nº Análisis</th>

                {/* Inv Inicial */}
                <th>Volumen (L)</th>
                <th>% Alc. Vol.</th>

                {/* Entradas */}
                <th>Procedencia</th>
                <th>Volumen (L)</th>
                <th>% Alc. Vol.</th>
                <th>Vol. Agua (L)</th>

                {/* Salidas */}
                <th>Volumen (L)</th>
                <th>% Alc. Vol.</th>
                <th>Destino</th>

                {/* Inv Final */}
                <th>Volumen (L)</th>
                <th>% Alc. Vol.</th>

                {/* Cierre */}
                <th>Observaciones</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {granelRecords.map((rec, i) => (
                <tr key={i}>
                  <td>{rec.fechaMovimiento}</td>
                  <td>{rec.idContenedor}</td>
                  <td style={{ fontWeight: 800 }}>{rec.noLote}</td>
                  <td>{rec.categoria}</td>
                  <td>{rec.clase}</td>
                  <td>{rec.ingrediente}</td>
                  <td>{rec.edad}</td>
                  <td>{rec.tipoMaguey}</td>
                  <td>{rec.noAnalisis}</td>

                  <td>{rec.invInicialVol} L</td>
                  <td>{rec.invInicialAlc}%</td>

                  <td>{rec.entradaProcedencia}</td>
                  <td>{rec.entradaVolumen} L</td>
                  <td>{rec.entradaAlc}%</td>
                  <td style={{ color: "var(--copper)" }}>{rec.entradaVolAgua} L</td>

                  <td>{rec.salidaVolumen} L</td>
                  <td>{rec.salidaAlc}%</td>
                  <td>{rec.salidaDestino}</td>

                  <td style={{ color: "var(--agave-green)", fontWeight: 700 }}>{rec.invFinalVol} L</td>
                  <td>{rec.invFinalAlc}%</td>

                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.observaciones}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nuevo Registro de Mezcal a Granel - Sección II</h2>
      </div>

      <div className="cards-container-grid">
        {/* SECCIÓN IDENTIFICACIÓN */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Identificación del Mezcal</h2>
              <p>Datos de lote, contenedor y clasificación comercial</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                id="fechaMovimiento" 
                value={fechaMovimiento} 
                onChange={e => setFechaMovimiento(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="fechaMovimiento">Fecha del Movimiento</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="idContenedor" 
                value={idContenedor} 
                onChange={e => setIdContenedor(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. C-01 / Tina 04"
              />
              <label className="custom-input-label" htmlFor="idContenedor">ID Contenedor</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                id="noLote" 
                value={noLote} 
                onChange={e => setNoLote(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. L-01-ENV"
              />
              <label className="custom-input-label" htmlFor="noLote">Nº de Lote</label>
            </div>

            <div className="custom-input-group">
              <select 
                value={categoria} 
                onChange={e => setCategoria(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Mezcal">Mezcal</option>
                <option value="Mezcal Artesanal">Mezcal Artesanal</option>
                <option value="Mezcal Ancestral">Mezcal Ancestral</option>
              </select>
              <label className="custom-input-label">Categoría</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={clase} 
                onChange={e => setClase(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Joven / Blanco">Joven / Blanco</option>
                <option value="Madurado en Vidrio">Madurado en Vidrio</option>
                <option value="Reposado">Reposado</option>
                <option value="Añejo">Añejo</option>
                <option value="Abocado con">Abocado con</option>
                <option value="Destilado con">Destilado con</option>
              </select>
              <label className="custom-input-label">Clase</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="ingrediente" 
                value={ingrediente} 
                onChange={e => setIngrediente(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Maguey Espadín"
              />
              <label className="custom-input-label" htmlFor="ingrediente">Ingrediente(s)</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                id="edad" 
                value={edad} 
                onChange={e => setEdad(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Sin edad / 2 meses"
              />
              <label className="custom-input-label" htmlFor="edad">Edad (meses o años)</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="tipoMaguey" 
                value={tipoMaguey} 
                onChange={e => setTipoMaguey(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Espadín"
              />
              <label className="custom-input-label" htmlFor="tipoMaguey">Tipo de Maguey(es)</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input 
              type="text" 
              id="noAnalisis" 
              value={noAnalisis} 
              onChange={e => setNoAnalisis(e.target.value)} 
              className="custom-input-field"
              placeholder="Ej. ANA-2026-98"
            />
            <label className="custom-input-label" htmlFor="noAnalisis">Nº de Análisis Fisicoquímico</label>
          </div>
        </section>

        {/* INVENTARIO INICIAL & ENTRADAS */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <ScienceIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Inicial & Entradas</h2>
              <p>Volumen de inicio, procedencias y ajuste con agua</p>
            </div>
          </header>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--text-color)", marginBottom: "8px" }}>INVENTARIO INICIAL</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={invInicialVol} 
                onChange={e => setInvInicialVol(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Inicial (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={invInicialAlc} 
                onChange={e => setInvInicialAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol. Inicial</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "16px" }}>ENTRADAS</h3>
          <div className="custom-input-group">
            <input 
              type="text" 
              value={entradaProcedencia} 
              onChange={e => setEntradaProcedencia(e.target.value)} 
              className="custom-input-field" 
              placeholder="Ej. Producción lote 01 / Compra"
            />
            <label className="custom-input-label">Procedencia</label>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={entradaVolumen} 
                onChange={e => setEntradaVolumen(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Entrada (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={entradaAlc} 
                onChange={e => setEntradaAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol.</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input 
              type="number" 
              value={entradaVolAgua} 
              onChange={e => setEntradaVolAgua(e.target.value)} 
              className="custom-input-field" 
            />
            <label className="custom-input-label">Volumen Agua para ajuste (L)</label>
            <span className="input-suffix">L</span>
          </div>
        </section>

        {/* SALIDAS & INVENTARIO FINAL */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <WaterDropIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Salidas e Inventario Final</h2>
              <p>Desglose de salidas de granel y saldos de cierre</p>
            </div>
          </header>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--text-color)", marginBottom: "8px" }}>SALIDAS</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={salidaVolumen} 
                onChange={e => setSalidaVolumen(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Salida (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={salidaAlc} 
                onChange={e => setSalidaAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol. Salida</label>
              <span className="input-suffix">%</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={salidaDestino} 
                onChange={e => setSalidaDestino(e.target.value)} 
                className="custom-input-field" 
                placeholder="Ej. Línea de Envasado"
              />
              <label className="custom-input-label">Destino</label>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "16px" }}>INVENTARIO FINAL CALCULADO</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={invFinalVol} 
                onChange={e => setInvFinalVol(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Final (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={invFinalAlc} 
                onChange={e => setInvFinalAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol. Final</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              id="observaciones" 
              value={observaciones} 
              onChange={e => setObservaciones(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Notas generales del movimiento de granel..."
            />
            <label className="custom-input-label" htmlFor="observaciones">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveGranel("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Sección II</span>
        </button>
      </div>
    </div>
  );
};

export default InventarioGranelSection;
